/* ============================================================
   FEATURED TABS - v143
   ------------------------------------------------------------
   Was an inline script inside sections/featured-tabs.liquid. Moved here so
   it is cached once instead of printed into the HTML of every page.

   1. Tab switching.
   2. Lazy panels. Only the first tab is rendered on the server. A panel
      carrying data-ftabs-src is filled from
      <collection url>?section_id=ftabs-panel the first time its tab is
      hovered, focused, touched or clicked. The request starts on hover or
      touch, so it is usually back before the click lands.
   3. Click-and-drag to scroll the rows with a mouse or pen (unchanged).

   If a request fails, the panel keeps its "View all" card, the tab can be
   tried again, and nothing else on the page is affected.
   ============================================================ */
(function () {
  'use strict';
  if (window.__toiFtabs) { return; }
  window.__toiFtabs = true;

  var cache = {};

  function load(src) {
    if (!cache[src]) {
      var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=ftabs-panel';
      cache[src] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) { throw new Error(r.status); }
          return r.text();
        })
        .catch(function (err) {
          delete cache[src];          /* let the next attempt try again */
          throw err;
        });
    }
    return cache[src];
  }

  /* Remove the card fields this section switches off. The panel renders
     every field, so this is the only place the per-section choice applies. */
  function trim(item, hide) {
    function drop(sel) {
      var els = item.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) { els[i].parentNode.removeChild(els[i]); }
    }
    if (hide.tag) { drop('.product-tag'); }
    if (hide.artist) { drop('.card-artist'); }
    if (hide.price) { drop('.product-price'); }
    if (hide.badge) { drop('.product-badge'); }
    if (hide.wish) { drop('.product-wishlist'); }
    if (hide.second) {
      var slides = item.querySelectorAll('.card-slide');
      for (var s = 1; s < slides.length; s++) { slides[s].parentNode.removeChild(slides[s]); }
    }
    var meta = item.querySelector('.product-meta');
    if (meta && !meta.children.length && !meta.textContent.trim()) { meta.parentNode.removeChild(meta); }
  }

  function readHide(root) {
    var out = {};
    (root.getAttribute('data-ftabs-hide') || '').split(',').forEach(function (k) {
      if (k) { out[k] = true; }
    });
    return out;
  }

  /* Saved hearts: wishlist.js paints buttons that exist at page load, so
     cards added later are painted here from the same store. */
  function paintWishlist(scope) {
    var wl = window.__toiWishlist;
    if (!wl) { return; }
    var btns = scope.querySelectorAll('.wishlist-btn[data-wishlist-handle]');
    for (var i = 0; i < btns.length; i++) {
      var on = wl.has(btns[i].getAttribute('data-wishlist-handle'));
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[i].setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  function skeleton(row, n) {
    var more = row.querySelector('.ftabs-more');
    for (var i = 0; i < n; i++) {
      var d = document.createElement('div');
      d.className = 'ftabs-item ftabs-skel';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<div class="product-card"><div class="product-media media-' + 'abcd'.charAt(i % 4) + '"></div><div class="product-name"></div></div>';
      row.insertBefore(d, more);
    }
  }

  function clearSkeleton(row) {
    var sk = row.querySelectorAll('.ftabs-skel');
    for (var i = 0; i < sk.length; i++) { sk[i].parentNode.removeChild(sk[i]); }
  }

  function fill(root, panel) {
    var src = panel.getAttribute('data-ftabs-src');
    if (!src || panel.getAttribute('data-ftabs-state')) { return; }
    var row = panel.querySelector('.ftabs-row');
    if (!row) { return; }
    var count = parseInt(root.getAttribute('data-ftabs-count'), 10) || 5;

    panel.setAttribute('data-ftabs-state', 'loading');
    panel.setAttribute('aria-busy', 'true');
    skeleton(row, count);

    load(src).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = doc.querySelectorAll('.ftabs-item');
      var hide = readHide(root);
      var more = row.querySelector('.ftabs-more');
      var frag = document.createDocumentFragment();
      for (var i = 0; i < items.length && i < count; i++) {
        var it = document.importNode(items[i], true);
        trim(it, hide);
        frag.appendChild(it);
      }
      clearSkeleton(row);
      row.insertBefore(frag, more);
      paintWishlist(row);
      panel.setAttribute('data-ftabs-state', 'done');
      panel.removeAttribute('aria-busy');
      row.scrollLeft = 0;
      /* theme.js sizes the row's progress bar on scroll */
      row.dispatchEvent(new Event('scroll'));
    }).catch(function () {
      clearSkeleton(row);
      panel.removeAttribute('data-ftabs-state');
      panel.removeAttribute('aria-busy');
    });
  }

  function panelFor(root, tab) {
    return root.querySelector('[data-fpanel="' + tab.getAttribute('data-ftab') + '"]');
  }

  function warm(root, tab) {
    var p = panelFor(root, tab);
    var src = p && p.getAttribute('data-ftabs-src');
    if (src && !p.getAttribute('data-ftabs-state')) { load(src).catch(function () {}); }
  }

  function initDrag(row) {
    /* NO setPointerCapture here: capturing retargets the click to the row,
       which silently kills product links. Drag engages only after 6px of
       movement, so a plain click always opens the product. */
    var down = false, dragging = false, startX = 0, startScroll = 0;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') { return; }
      if (e.button !== undefined && e.button !== 0) { return; }
      down = true; dragging = false;
      startX = e.clientX; startScroll = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) { return; }
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 6) {
        dragging = true;
        row.style.scrollBehavior = 'auto';   /* 1:1 drag, no easing lag */
        row.classList.add('is-dragging');
      }
      if (dragging) { row.scrollLeft = startScroll - dx; }
    });
    window.addEventListener('pointerup', function () {
      if (!down) { return; }
      down = false;
      if (dragging) {
        row.style.scrollBehavior = '';
        setTimeout(function () { row.classList.remove('is-dragging'); dragging = false; }, 50);
      }
    });
    /* after a real drag, swallow the click so a card doesn't open mid-swipe */
    row.addEventListener('click', function (e) {
      if (dragging) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    row.addEventListener('dragstart', function (e) { if (dragging) { e.preventDefault(); } });
  }

  function init(root) {
    if (root.getAttribute('data-ftabs-ready')) { return; }
    root.setAttribute('data-ftabs-ready', '1');

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ftab]');
      if (!tab || !root.contains(tab)) { return; }
      var i = tab.getAttribute('data-ftab');
      var tabs = root.querySelectorAll('[data-ftab]');
      for (var t = 0; t < tabs.length; t++) {
        var on = tabs[t].getAttribute('data-ftab') === i;
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var panels = root.querySelectorAll('[data-fpanel]');
      for (var p = 0; p < panels.length; p++) {
        panels[p].classList.toggle('is-active', panels[p].getAttribute('data-fpanel') === i);
      }
      fill(root, panelFor(root, tab));
    });

    /* start the request on intent, ahead of the click */
    ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
      root.addEventListener(ev, function (e) {
        var tab = e.target.closest ? e.target.closest('[data-ftab]') : null;
        if (tab) { warm(root, tab); }
      }, { passive: true });
    });

    var rows = root.querySelectorAll('.ftabs-row');
    for (var r = 0; r < rows.length; r++) { initDrag(rows[r]); }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-ftabs]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
